import React from "react";

import "./LatestNewsBlock.css";
const LatestNewsBlock = (props) => {
  return (
    <>
      <div className="Latest-news">
        <div className="Latest_news_img">
          <img src={props.img} alt="LatestNews"></img>
        </div>
        <div className="LatestNews_desc">
          <span>{props.date}</span>
          <h2>{props.title}</h2>
          <p>{props.description} ...</p>
          <button>Read More</button>
        </div>
      </div>
    </>
  );
};

export default LatestNewsBlock;
